import type { KnowledgeEntry } from '@/features/editor/types/knowledge.types'

export function normalizeEntry(entry: KnowledgeEntry): KnowledgeEntry {
  const next: KnowledgeEntry = { ...entry, isUserCard: Boolean(entry.isUserCard) }

  // 避免用户不小心在开头打空格
  next.title = next.title.trimStart()

  // 非 prompt：强制清空 keywords（符合你后端 5/6 字段约定）
  if (next.retrievalMethod !== 'prompt') {
    return { ...next, keywords: [], keywordOp: 'or' }
  }

  // prompt：keywords 去重、trim、过滤空
  const cleaned = (next.keywords ?? []).map((s) => s.trim()).filter(Boolean)
  const deduped = Array.from(new Set(cleaned))

  return {
    ...next,
    keywords: deduped,
    keywordOp: next.keywordOp ?? 'or',
  }
}
